import React, { useState } from 'react';
import Collapse from 'react-bootstrap/lib/Collapse';
// import I18nLink from '~/components/I18nLink';
import IconArrowDown from '~/components/svg/icon-arrow-down.svg';
import config from '~/config';
import IconCreditCard from '~/components/svg/creditcard-face.svg';
// import themeVariables from '~/shared/themeVariables';

function StandardLicense({ t, isPremium, photo, currentLanguage }) {
  const [openStandardLicenseForm, setOpenStandardLicenseForm] = useState(true);
  // const faqLink =
  //   lng === 'tw'
  //     ? 'https://global.help.freebie-ac.jp/tw/category/36/Usage-Guides'
  //     : 'https://global.help.freebie-ac.jp/en/category/36/Usage-Guides ';
  const title = config.getTitleByLanguage(photo.title, currentLanguage);
  const validateTitle = title.replace('&amp;', '&');
  return (
    <>
      <div className={`container-license ${isPremium ? 'premium' : ''}`}>
        <div
          className={`content-license ${isPremium ? 'premium' : ''}`}
          onClick={() => setOpenStandardLicenseForm(!openStandardLicenseForm)}
        >
          <span className="icon-license">
            <IconCreditCard
              style={{
                transform: 'scale(0.8)',
              }}
            />
            {/* <img
              src={`${config.staticPrefix}/static/assets/image/download-pages/creditcard-face.svg`}
              height={24}
              width={24}
              alt="icon license"
            /> */}
          </span>
          {t('standard_license')}
        </div>
        <IconArrowDown
          style={{ height: 16 }}
          onClick={() => setOpenStandardLicenseForm(!openStandardLicenseForm)}
        />
      </div>
      <Collapse in={openStandardLicenseForm} className="data-collapse">
        <h2 className="note-license">
          {/* {t('text_license')} */}
          {t(config.getPrefixContent('text_license_title'), {
            title: validateTitle,
          })}

          <a
            target="_blank"
            className="link-creator"
            href="/help-page?tab=usage_guides"
            rel="noreferrer"
          >
            {t('read_more')}
          </a>
        </h2>
      </Collapse>

      {/* <p
        className="note"
        dangerouslySetInnerHTML={{
          __html: t('text_license_02', {
            propertyReleaseURL_01: '/hihihihi',
            propertyReleaseURL_02: '/hihihihi',
          }),
        }}
      ></p> */}

      <style jsx>
        {`
          .data-collapse {
            max-width: 100%;
          }
          .container-license {
            display: flex;
            flex-direction: row;
            align-items: center;
            height: 48px;
            border-radius: 4px;
            margin-top: 16px;
            background: #ecf1f4;
            justify-content: space-between;
            padding: 0 8px;
          }
          .icon-license {
            margin-right: 8px;
          }
          .content-license {
            display: flex;
            flex-direction: row;
            align-items: center;
            height: 100%;
            border-radius: 4px;
            font-weight: 700;
            width: 100%;
            height: 48px;
          }
          .container-license.premium {
            justify-content: space-between;
          }
          .content-license.premium {
            justify-content: unset;
          }
          .note-license {
            margin-top: 4px;
            width: 100%;
            font-size: 16px;
            line-height: 1.5;
          }
          .link-creator {
            font-weight: 700;
          }
          .link-creator:hover {
            text-decoration-line: underline !important;
            opacity: 0.8;
          }
        `}
      </style>
    </>
  );
}

export default StandardLicense;
